import * as TypeStyle from 'typestyle';

export const TextColors = {
  Primary: '#333',
  Secondary: '#4f4f4f',
  Neutral: '#707070',
  Disabled: '#bfbfbf',
  Error: '#c93a47',
  Valid: '#008057',
};

export const IconFillColors = {
  Rest: '#666',
  Hover: '#333',
  Disabled: '#bfbfbf',
  Error: '#c93a47',
  Valid: '#008057',
  Warning: '#FECA56',
  Info: '#2979B2',
};

export const TextFieldBorderColors = {
  Rest: '#cbcbcb',
  Disabled: '#bfbfbf',
  Hover: '#333',
  Error: '#c93a47',
  Valid: '#008057',
};

export const InvertTextColors = {
  Primary: '#fff',
  Secondary: 'rgba(255, 255, 255, 0.96)',
  Netural: 'rgba(255, 255, 255, 0.56)',
  Disabled: 'rgba(255, 255, 255, 0.35)',
};

export const InvertIconFillColors = {
  Rest: 'rgba(255, 255, 255, 0.5)',
  Hover: 'rgba(255, 255, 255, 0.8)',
  Disabled: 'rgba(255, 255, 255, 0.35)',
};
export const InvertBorderColors = {
  Rest: 'rgba(255, 255, 255, 0.5)',
  Hover: '#fff',
  Disabled: 'rgba(255, 255, 255, 0.35)',
};

export const TextFieldHoverColor = '#fafafa';

export const InteractiveBorderColors: TypeStyle.types.NestedCSSProperties = Object.freeze({
  borderColor: TextFieldBorderColors.Rest,
  $nest: {
    '&:hover': { borderColor: TextFieldBorderColors.Hover },
    '&:active': { borderColor: TextFieldBorderColors.Hover },
    '&:disabled': { borderColor: `${TextFieldBorderColors.Disabled}` },
  }
});

export const InvertInteractiveBorderColors: TypeStyle.types.NestedCSSProperties = Object.freeze({
  borderColor: InvertBorderColors.Rest,
  $nest: {
    '&:hover': { borderColor: InvertBorderColors.Hover },
    '&:active': { borderColor: InvertBorderColors.Hover },
    '&:disabled': { borderColor: `${InvertBorderColors.Disabled}` },
  }
});
